import styled from 'styled-components';

export const Container = styled.div`
  background-color: white;
  padding: 10px 25px 25px 25px;
  border-radius: 4px;
  box-shadow: 0 0 1px #eaeaea inset;
`;

export const Title = styled.h1`
  font-size: 16px;
  color: #2c2c2c;
`;

export const TaskExternalLink = styled.div`
  width: 20%;
  font-size: 14px;
  color: #8e8e8e;
  display: flex;
  justify-content: end;
  align-items: center;

  span {
    margin-left: 8px;
    font-weight: 300;
  }
`;
